import { defineMessages } from 'react-intl';

export default defineMessages({
  poweredByText: {
    defaultMessage: 'Powered by',
    id: 'atoms.poweredByVimFooter.poweredBy',
  },
});
